<template>

  
    <div ref="sessionCardRef" class="absolute w-full flex justify-center" v-if="loading">
                
        <ring-loader class="rounded-full bg-red-500" ></ring-loader> 
    </div>

    <div v-else @click="callShowDescription" class="text-xs lg:text-base">
        
        <div>

            <div class="h-20">
                <div v-if="cardImages.length > 0" class="opacity-50">

                    <card-images-component :images="cardImages" ref="imageComponent" :isFromPitchCard="true"/>
                </div>

                <!-- <div class="absolute">

                    <div class="-mt-20">

                        <label class="myOverlayText h-10 text-xl">Test</label>
                    </div>
                </div> -->

                <div class="myCenter" v-touch:swipe.left="swipeLeft" v-touch:swipe.right="swipeRight" :isTransparent="true">

                    <div class="pitch2CardDivClass">
                        
                        <card-details-component :mySlot="mySlot"  :key="dayDate" :isOnline="true"
                        :email="email" :myReload="myReload" :isCard="false" :displayModal="displayModal"
                       :index="index" :dayDate="dayDate"
                        :disablePage="disablePage" :showDescription="showDescription" :showPitchPage="showPitchPage"
                        :searchStartTime="searchStartTime" :searchEndTime="searchEndTime"
                        :disableButton="disableButton" :openOneSlotMapModal="openOneSlotMapModal"/>
                    </div>            
                </div>
            </div>

                    <!-- <pitch-time-slot v-if="showTime(time)" -->
                    <!-- <div class="bg-gray-400 w-20 lg:w-40" v-else>

                        <label>{{time}}</label>
                    </div> -->

            <div class="flex justify-around flex-wrap text-xs lg:text-lg mt-10 divide-x-4" >

                <div class="w-16 lg:w-40 mb-1" v-for="(time, i) in allTimes" :key="i">
                    
                    <pitch-time-slot :showTime="showTime(time)"
                    :mySlot="mySlot" :index="i" :time="transferTime(time)" :endTime="transferTimeOfEndTime(time)" :dayDate="dayDate" 
                    ></pitch-time-slot>

                </div>  
            </div>  
        </div>

    </div>

</template>

<script>

import { RingLoader } from 'vue-spinners-css';

import moment from 'moment';

import cardImagesComponent from '../../components-v2/cards-components/CardImages'

import cardDetailsComponent from './PitchCardDetails'

import componentsHelpers from '../../classes/componentHelpers';

import pitchTimeSlot from './PitchTimeSlot';

import componentsMethods from '../../classes/componentsMethods';

export default {

    mounted(){

        // console.log(`pitch card mounted`);
        // console.log(`mySlot: ${JSON.stringify(this.mySlot)}`);
        // console.log(`mounted startTime: ${this.searchStartTime}`)
            
        // console.log(`mounted endTime: ${this.searchEndTime}`)

        const tempImages = new Array();

        tempImages.push(this.mySlot.two_pitch.image_1);
        tempImages.push(this.mySlot.two_pitch.image_2);
        tempImages.push(this.mySlot.two_pitch.image_3);
        tempImages.push(this.mySlot.two_pitch.image_4);
        
        tempImages.push(this.mySlot.two_pitch.image_5);
        tempImages.push(this.mySlot.two_pitch.image_6);
        tempImages.push(this.mySlot.two_pitch.image_7);
        tempImages.push(this.mySlot.two_pitch.image_8);

        for(let i = 0; i < 8; i++){
            
            if(tempImages[i] != ''){

                this.cardImages.push(tempImages[i]);
            }
        }

        if(this.cardImages.length == 0){

            this.cardImages.push(this.mySlot.two_pitch.business.logo);
        }

        this.type = this.mySlot.two_pitch.type.name;
    },

    props:{

        email: '',

        index: 0,
        
        openOneSlotMapModal: {

            type: Function
        },

        showDescription: {

            type: Function
        },

        disableButton: false,

        disablePage: false,

        dayDate: '',

        addBookingTime: {

            type: Function
        },

        removeBookingTime: {

            type: Function
        },

        searchStartTime: '',

        searchEndTime: '',

        mySlot:{

            type: Object
        },

        businessInfo:{
      
            type: Object,
        },

        displayModal: {

            type: Function
        },

        myReload: {

            type: Function
        },

        showPitchPage:{

            type: Function
        },

    },

    components:{

        // pitchTimeSlot,
        cardImagesComponent,
        cardDetailsComponent,
        pitchTimeSlot
    },

    methods:{

        swipeLeft(){

            this.$refs.imageComponent.swipeLeft();
            // console.log(`swipeLeft`);
        },
        
        swipeRight(){

            this.$refs.imageComponent.swipeRight();

            // console.log(`swipeRight`);
        },  

        callShowDescription(){

            // console.log(`in callShowDescription`);

            // console.log(`here ${JSON.stringify(this.mySlot)}`);
            this.showDescription(this.mySlot);
        },


        showTime(time){
            
            const startTime = moment(new Date(`1970/01/01 ${this.searchStartTime}`));

            // console.log(`startTime: ${this.searchStartTime}`)
            
            const endTime = moment(new Date(`1970/01/01 ${this.searchEndTime}`));
            // console.log(`endTime: ${this.searchEndTime}`)

            const  todayDate = moment(new Date()).format(moment.HTML5_FMT.DATE);

            const  timeNow = moment(new Date()).format('hh:mm a');

            const currentTime = moment(new Date(`1970/01/01 ${time}`));
            
            if(moment(currentTime).isSameOrAfter(startTime) && moment(currentTime).isSameOrBefore(endTime)){

                if(moment(this.dayDate).isSame(todayDate))
                {   
                    // console.log(`in same day`);
                    if(!moment(timeNow, 'hh:mm a').isSameOrBefore(moment(time, 'hh:mm'))){

                        // console.log(`false`)
                        return false;
                    }
                    
                    // console.log(`true`)
                    return true;
                }else{

                    // console.log(`true`)
                    return true;
                }
            }
            // console.log(`false`)

           return false;
        },

        transferTime(time){

            return moment(new Date(`1970/01/01 ${time}`)).format('hh a');
        },

        transferTimeOfEndTime(time){

            return moment(new Date(`1970/01/01 ${time}`)).add(1,'hour').format('hh a');
        },

    },

    data:function(){

        return{


            loading: false,            
            cardImages:[],
            modalImages: [],
            type: '',

            allTimes: componentsMethods.allTimes,

        tempAllTimes: ['05:00', '05:30', '06:00', '06:30', '07:00', '07:30', '08:00', '08:30',
            '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '12:30',
            '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00','16:30',
            '17:00', '17:30', '18:00', '18:30', '19:00', '19:30', '20:00', '20:30',
            '21:00', '21:30', '22:00', '22:30', '23:00', '23:30','00:00', '00:30',
            '01:00', '01:30', '02:00', '02:30', '03:00',  '03:30', '04:00', '04:30'],

        }
    }
}
</script>

<style>

</style>